/**
 * Pixel sizes in the editor (subtitle fontSize, text-layer fontSize, etc.)
 * are authored against a 1080p frame: 1080×1920 portrait or 1920×1080
 * landscape. The preview Player always uses that size. Free-plan exports
 * render at 720p (720×1280 / 1280×720), so the same raw px would look 1.5×
 * larger. Scale by the short side vs 1080 so both orientations stay WYSIWYG.
 */
export const DESIGN_SHORT_SIDE_PX = 1080;

export function designScale(width: number, height: number): number {
  const short = Math.min(width, height);
  if (!Number.isFinite(short) || short <= 0) return 1;
  return short / DESIGN_SHORT_SIDE_PX;
}

export function scaleDesignPixels(
  px: number,
  width: number,
  height: number,
): number {
  return px * designScale(width, height);
}
